<app-upsell-card
  [htmlTitle]="htmlTitle"
  [question]="question"
  [slug]="slug"
  [options]="options"
  [additionalFormsToValidate]="additionalFormsToValidate"
  (optionSelected)="onOptionSelected($event)"
  (continueButtonPressed)="onContinueButtonPressed($event)"
  [hints]="hints"
>
  <ng-content></ng-content>
  <div bottomContent *ngIf="edTreatmentForm">
    <div class="mt-4">
      <app-radios-error-field
        [controlName]="edTreatmentControlName"
        [form]="edTreatmentForm"
        label="Which medication would you prefer? (Sildenafil or Tadalafil)"
        [options]="edTreatmentOptions"
      ></app-radios-error-field>
    </div>
  </div>
</app-upsell-card>
